/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function MerchantCleanUpRouter($stateProvider) {
  $stateProvider
    .state('app.ops-support-merchant-clean-up', {
      url: '/ops-support/merchant-clean-up',
      template: '<app-merchant-clean-up></app-merchant-clean-up>',
    })
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.router.js